export default "__VITE_ASSET__BRygqGb4__"